<template>
    <div class="story">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <Stories :stories="stories"></Stories>
    </div>
</template>

<script>
    import Carousel from '../components/common/Carousel'
    import Stories from '../components/container/story/Stories'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'seriesDetail',
        components: {
            Carousel,
            Stories,
        },
        computed: {
            ...mapState('story', {
                banners: ({banners}) => {
                    return banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'allSeries' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            imgSrc: banner.src_file,
                            width: 1680,
                            height: 600,
                        }
                    })
                },
                stories: ({stories}) => {
                    const lang = localStorage.getItem('lang') || 'cn'
                    let items = stories.data.map(story => {
                        return {
                            parentPath: '/stories/',
                            imgSrc: story.cover_pic,
                            name: story.title,
                            desc: story.excerpt,
                            link: lang === 'cn' ? '查看此项' : 'View Story',
                            url: '',
                            slug: story.slug
                        }
                    })

                    return {
                        //title: stories.title,
                        title: stories.description,
                        desc: stories.description,
                        items: items
                    }
                },

            })
        },
        methods: {
            ...mapActions('story', ['getPageInfo'])
        },
        created() {
            this.getPageInfo(this.$route.path.replace('/',''))
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .series-container {
        margin-top: 100px;
    }
</style>
